export default "__VITE_ASSET__c3a80edd__"